import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  $compact?: boolean
}

const TableTitle: React.ComponentType<Props> = tw.div`
  bg-gray-50
  border-gray-200
  border-l
  border-r
  border-t
  flex
  items-center
  justify-center
  md:text-base
  px-6
  py-3
  text-center
  text-txt-emphasis
  text-xs
  w-full

  ${({ $compact }: Props) => {
    if ($compact) {
      return `
        py-2

      `
    }
    return ``
  }}
`

export default TableTitle
